import { satisfies } from 'compare-versions';

import { Addon } from '@cast/types-omni';

/**
 * Returns true when the cluster's omni-agent version satisfies the addon's
 * `minimumOmniAgentVersion` constraint.
 *
 * The omni API returns `omniAgentVersion` as clean semver (e.g. `1.14.0`),
 * but it can be absent while the agent has not yet reported. In that case
 * we treat the addon as compatible so the UI stays usable.
 */
export const isOmniAddonCompatible = (
  addon: Addon | undefined,
  omniAgentVersion: string | undefined
): boolean => {
  const minimumVersion = addon?.minimumOmniAgentVersion;
  if (!minimumVersion || !omniAgentVersion) {
    return true;
  }

  return satisfies(omniAgentVersion, `>=${minimumVersion}`);
};
